import { render, staticRenderFns } from "./DashboardCardItem.vue?vue&type=template&id=1c73bbc4&scoped=true&"
import script from "./DashboardCardItem.vue?vue&type=script&lang=js&"
export * from "./DashboardCardItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardItem.vue?vue&type=style&index=0&id=1c73bbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73bbc4",
  null
  
)

export default component.exports